export const SITE_NAME = "Ekselencia";
export const SITE_URL = "https://ekselencia.com";
export const SITE_DESCRIPTION = "Ecosistema fitness local donde descubres gimnasios, entrenadores y profesionales del bienestar validados por tu comunidad. +1.800 profesionales verificados en 157 ciudades.";
export const SITE_KEYWORDS = [
  "ecosistema fitness local",
  "comunidad fitness España",
  "gimnasios cerca de mi",
  "votos de confianza fitness",
  "entrenadores verificados",
  "ranking gimnasios ciudad",
  "centros fitness España",
  "yoga",
  "pilates",
  "crossfit",
  "directorio deportivo",
  "instalaciones deportivas",
];

export const BUSINESS_INFO = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.webp`,
  description: SITE_DESCRIPTION,
  // Note: PostalAddress omitted - Google requires streetAddress, addressLocality, and postalCode
  // when including address. We don't have a physical address for the organization.
};

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const SEO_CONFIG = {
  titleTemplate: `%s | ${SITE_NAME}`,
  defaultTitle: `${SITE_NAME} - Tu Ecosistema Fitness Local`,
  description: SITE_DESCRIPTION,
  openGraph: {
    type: "website",
    locale: "es_ES",
    url: SITE_URL,
    siteName: SITE_NAME,
    images: [
      {
        url: DEFAULT_OG_IMAGE,
        width: 1200,
        height: 630,
        alt: SITE_NAME,
      },
    ],
  },
  twitter: {
    cardType: "summary_large_image",
    site: "@ekselencia",
  },
};
